import { render, staticRenderFns } from "./EditRadio.vue?vue&type=template&id=2dd1bc6c"
import script from "./EditRadio.vue?vue&type=script&lang=js"
export * from "./EditRadio.vue?vue&type=script&lang=js"
import style0 from "./EditRadio.vue?vue&type=style&index=0&id=2dd1bc6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports